import React from "react";

import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

import { TaskV4Dto } from "@fartherfinance/frontend/api/TaskWorkflows/hooks/useGetTasks";

import TaskProgressIndicator from "../../../TaskProgressIndicator/TaskProgressIndicator";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./TableTaskTitle.module.css";

interface TableTaskTitleProps {
  task: TaskV4Dto;
}

const TableTaskTitle: React.FC<TableTaskTitleProps> = ({ task }) => {
  const subtasks = task.children.tasks;

  return (
    <div className={styles.taskTitleContainer}>
      <Text className={styles.shrinkLess} variant="body" noWrap>
        {task.fields.title}
      </Text>

      {subtasks.length > 0 && (
        <TaskProgressIndicator task={task} subtasks={subtasks} />
      )}

      {task.parent && (
        <div className={styles.parentTaskContainer}>
          <ChevronRightRoundedIcon className={styles.icon} />
          <Text
            className={styles.shrinkMore}
            variant="body"
            color="textSubtle"
            noWrap
          >
            {task.parent.title}
          </Text>
        </div>
      )}
    </div>
  );
};

export default TableTaskTitle;
